import { getCookie, setCookie } from './cookies';

const COOKIE_NAME = 'rvd_consent_v2';

/**
 * Google Consent Mode v2 keys.
 * We always grant functionality/security; others depend on user choice.
 */
export function buildConsentPayload(prefs) {
  const analytics = !!prefs.analytics;
  const ads = !!prefs.ads;

  return {
    ad_storage: ads ? 'granted' : 'denied',
    analytics_storage: analytics ? 'granted' : 'denied',
    ad_user_data: ads ? 'granted' : 'denied',
    ad_personalization: ads ? 'granted' : 'denied',
    functionality_storage: 'granted',
    security_storage: 'granted',
  };
}

export function ensureGtag() {
  window.dataLayer = window.dataLayer || [];
  // eslint-disable-next-line no-unused-vars
  window.gtag = window.gtag || function gtag(){ window.dataLayer.push(arguments); };
}

/**
 * Set Google Consent default (denied) BEFORE any tags fire.
 * If a stored consent exists, we update right away.
 */
export function initConsentMode() {
  ensureGtag();

  // Default: deny analytics/ads until user action.
  window.gtag('consent', 'default', {
    ad_storage: 'denied',
    analytics_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    functionality_storage: 'granted',
    security_storage: 'granted',
    // Gives time for banners to update consent before tags fully run.
    wait_for_update: 500
  });

  const stored = readStoredConsent();
  if (stored) {
    window.gtag('consent', 'update', buildConsentPayload(stored));
  }
}

export function readStoredConsent() {
  try {
    const raw = getCookie(COOKIE_NAME);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return null;
    // normalize
    return {
      analytics: !!parsed.analytics,
      ads: !!parsed.ads,
      ts: parsed.ts || null
    };
  } catch (e) {
    return null;
  }
}

export function storeConsent(prefs, days = 180) {
  const payload = {
    analytics: !!prefs.analytics,
    ads: !!prefs.ads,
    ts: Date.now()
  };
  setCookie(COOKIE_NAME, JSON.stringify(payload), days);
  return payload;
}

export function updateConsent(prefs) {
  ensureGtag();
  window.gtag('consent', 'update', buildConsentPayload(prefs));
}
